import api from "@/router/api";

export default {
  async buscaGeral(termo, tipo = "GERAL", page = 0, size = 10) {
    const params = {
      input: termo,
      page,
      size,
    };
    if (tipo && tipo !== "GERAL") {
      params.tipo = tipo;
    }
    const response = await api.get("/busca-geral", { params });
    return response.data;
  },
};
